<template>
  <div>
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab class="mtg-trans-browse-received-of"
        :to="{ name: 'Mortgage Tax - Received Of' }"
      >
      Received Of
      </v-tab>
      <v-tab class="mtg-trans-browse-exempt-mortgagees"
        :to="{ name: 'Mortgage Tax - Exempt Mortgagees' }"
      >
      Exempt Mortgagees
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'MtgBrowse',
  components: {
  },
};
</script>
